<template>
    <div class="form-container">
        <form @submit.prevent>
                <label for="email">Email adress</label>
                <input v-model="email" type="email" id="email">

                <label for="password">Password</label>
                <input v-model="password" type="password" id="password">

                <div v-if="badCredentialsMessage" class="invalidCredentials">
                    Invalid credentials
                </div>
                <button :class="{loading}" @click="logUser">Login</button>

                <div class="actions">
                    <router-link :to="{name: 'subscribe'}">Not yet registred?</router-link>
                    <router-link :to="{name: 'lost-password'}">Lost password?</router-link>
                </div>
        </form>

        <div v-if="error != ''" class="error" @click="error = ''">
            {{ error }}
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'Login',

        data() {
            return {
                email: '',
                password: '',
                badCredentialsMessage: false,
                error: '',
                loading: false
            };
        },
        methods: {
            ...mapActions('security', [
                'login'
            ]),

            logUser() {
                this.badCredentialsMessage = false;
                this.loading = true;
                if (this.email === '' || this.password === '') return false;
                this.login({email: this.email, password: this.password})
                    .then(() => {
                        this.loading = false;
                        this.$router.push({name: "admin_products"})
                    })
                    .catch(() => {
                        this.loading = false;
                        this.badCredentialsMessage = true;
                    });
                return false;
            }
        }
    };
</script>

<style scoped lang="scss">
    form{
        width: 500px;
        margin: 100px auto auto;
        border-radius: 5px;
        padding: 40px;
        color: white;
        background-color: var(--main-green);

        label{
            display: block;
            width: 60%;
            margin: auto;
            text-align: left;
        }

        input[type="text"], input[type="email"], input[type="password"]{
            font-size: 14px;
            display: block;
            width: 60%;
            height: 30px;
            margin: auto auto 30px;
            border: 1px solid;
            border-radius: 2px;
            padding: 3px;
        }

        button{
            font-size: 15px;
            font-weight: 700;
            display: block;
            width: 40%;
            margin: auto;
            border: 0;
            border-radius: 3px;
            padding: 5px;
            color: var(--main-green);
            background-color: #bbb;
            cursor: pointer;
        }

        .actions{
            font-size: 14px;
            margin-top: 20px;

            a{
                display: block;
                color: #fff;
                text-align: center;

                &:last-of-type{
                    margin-top: 10px;
                }
            }
        }
    }
</style>
